export const isUpsellPurchaseRoute = (path: string) =>
    path.startsWith("/upsell") ||
    path.startsWith("/assistant") ||
    path.startsWith("/ai-tools") ||
    /^\/course\/\d+\/topic\/\d+\/lesson\/\d+/.test(path);
